//Libraries
import { useState } from "react";
import { useRouter } from "next/router";
import { useUser } from "@auth0/nextjs-auth0";

//Services
import { postForm } from "../services/formService";

//Components
import Header from "../components/Header";
import Footer from "../components/Footer";

//Custom Hooks
import useInput from "../hooks/use-input";

export default function ContactUs() {
  const { user, error, isLoading } = useUser();

  const router = useRouter();

  const [saving, setSaving] = useState(false);

  const [cart, setCart] = useState([]);

  const { value: firstName, isValid: firstNameIsValid, hasError: firstNameHasError, valueChangeHandler: firstNameChangeHandler, inputBlurHandler: firstNameBlurHandler, reset: firstNameReset } = useInput((value) => value.trim() !== "" && /^[a-zA-Z\s]+$/.test(value.trim()));
  const { value: lastName, isValid: lastNameIsValid, hasError: lastNameHasError, valueChangeHandler: lastNameChangeHandler, inputBlurHandler: lastNameBlurHandler, reset: lastNameReset } = useInput((value) => value.trim() !== "" && /^[a-zA-Z\s]+$/.test(value.trim()));
  const { value: email, isValid: emailIsValid, hasError: emailHasError, valueChangeHandler: emailChangeHandler, inputBlurHandler: emailBlurHandler, reset: emailReset } = useInput((value) => value.trim() !== "");
  const { value: description, isValid: descriptionIsValid, hasError: descriptionHasError, valueChangeHandler: descriptionChangeHandler, inputBlurHandler: descriptionBlurHandler, reset: descriptionReset } = useInput((value) => value.trim() !== "");

  let formIsValid = true;

  if (!firstNameIsValid || !lastNameIsValid || !emailIsValid || !descriptionIsValid) {
    formIsValid = false;
  }

  const formSubmissionHandler = async (event) => {
    event.preventDefault();

    if (!formIsValid) {
      return;
    }

    setSaving(true);

    let response = await postForm("", {
      name: firstName,
      last: lastName,
      email: email,
      message: description,
    });

    if (!response) {
      setSaving(false);

      return;
    }

    firstNameReset();
    lastNameReset();
    emailReset();
    descriptionReset();

    setTimeout(() => {
      router.push("/");
    }, 500);
  };

  return (
    <div className="bg-white pt-20">
      {/* Menu */}
      <Header user={user} cart={cart} setCart={setCart} />

      {/* Body */}
      <div className="min-h-screen bg-gray-50 flex">
        <div className="hidden lg:block relative w-0 flex-1 bg-contact-us bg-cover"></div>
        <div className="flex-1 flex flex-col w-3/5 justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div>
            <h2 className="mt-6 text-4xl font-bold text-gindo font-serif">Contact</h2>
          </div>

          <div className="mt-8">
            <form className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" onSubmit={formSubmissionHandler}>
              <div>
                <label htmlFor="first_name" className="block text-sm font-medium text-warm-gray-900">
                  First Name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="first_name"
                    id="first_name"
                    autoComplete="given-name"
                    className={(firstNameHasError ? "border-red-300" : "border-gray-300") + " py-3 px-4 block w-full shadow-sm text-warm-gray-900 focus:ring-gold-300 focus:border-gold-300 rounded-md"}
                    value={firstName}
                    onChange={firstNameChangeHandler}
                    onBlur={firstNameBlurHandler}
                    placeholder="John"
                  />
                </div>
                {firstNameHasError && (
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                    Please enter your first name, only letters are allow.
                  </p>
                )}
              </div>
              <div>
                <label htmlFor="last_name" className="block text-sm font-medium text-warm-gray-900">
                  Last Name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="last_name"
                    id="last_name"
                    autoComplete="family-name"
                    className={(lastNameHasError ? "border-red-300" : "border-gray-300") + " py-3 px-4 block w-full shadow-sm text-warm-gray-900 focus:ring-gold-300 focus:border-gold-300 rounded-md"}
                    value={lastName}
                    onChange={lastNameChangeHandler}
                    onBlur={lastNameBlurHandler}
                    placeholder="Doe"
                  />
                </div>
                {lastNameHasError && (
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                    Please enter your last name, only letters are allow.
                  </p>
                )}
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-warm-gray-900">
                  Email
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="family-name"
                    className={(emailHasError ? "border-red-300" : "border-gray-300") + " py-3 px-4 block w-full shadow-sm text-warm-gray-900 focus:ring-gold-300 focus:border-gold-300 rounded-md"}
                    value={email}
                    onChange={emailChangeHandler}
                    onBlur={emailBlurHandler}
                    placeholder="youremail@domain.com"
                  />
                </div>
                {emailHasError && (
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                    Please enter your email.
                  </p>
                )}
              </div>
              <div></div>
              <div className="col-span-2">
                <label htmlFor="description" className="block text-sm font-medium text-warm-gray-900">
                  Description
                </label>
                <div className="mt-2">
                  <textarea
                    type="text"
                    name="description"
                    id="description"
                    rows="6"
                    className={(descriptionHasError ? "border-red-300" : "border-gray-300") + " py-3 px-4 block w-full shadow-sm text-warm-gray-900 focus:ring-gold-300 focus:border-gold-300 rounded-md"}
                    value={description}
                    onChange={descriptionChangeHandler}
                    onBlur={descriptionBlurHandler}
                    placeholder="Tell us more about your situation"
                  />
                </div>
                {descriptionHasError && (
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                    Please enter a description.
                  </p>
                )}
              </div>

              <div className="mt-12 gap-4 sm:col-span-2 sm:flex sm:justify-center">
                <button
                  type="button"
                  className="w-full inline-flex items-center justify-center px-8 py-2 border border-transparent text-base font-medium rounded-md  sm:w-auto text-gold-600 border-gold-600 bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold-500 sm:text-sm"
                  onClick={() => router.back()}
                >
                  Back
                </button>
                <button type="submit" className="flex justify-center items-center px-8 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gold-600 hover:bg-gold-700 disabled:opacity-75 disabled:cursor-default" disabled={saving}>
                  {saving && (
                    <svg className="animate-spin mr-3 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  )}
                  {saving ? "Sending..." : "Send"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
